import { Table } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

const CodeBlock = ({ code }: { code: string }) => (
    <pre className="mb-0 small bg-light p-2 rounded border overflow-auto">{code}</pre>
);

const SourceLeadsHelp = () => {
    const { t } = useTranslation(['Settings']);
    const origin = typeof window !== 'undefined' ? window.location.origin : 'https://your-domain.com';
    const scriptExample = `<script src="${origin}/public/form-capture.js?sourceId=YOUR_SOURCE_ID" defer></script>`;
    const scriptParams = ['sourceId', 'endpoint', 'powDifficulty', 'maxForms'] as const;
    const fieldGroups = ['name', 'phone', 'email', 'message'] as const;

    return (
        <div>
            <h6 className="mb-2">{t('sourceLeads.help.title')}</h6>
            <p className="text-muted fs-12 mb-3">{t('sourceLeads.help.intro')}</p>

            <h6 className="mb-2 fs-12">{t('sourceLeads.help.step1Title')}</h6>
            <p className="fs-12 mb-3">{t('sourceLeads.help.step1')}</p>

            <h6 className="mb-2 fs-12">{t('sourceLeads.help.step2Title')}</h6>
            <p className="fs-12 mb-2">{t('sourceLeads.help.step2')}</p>
            <CodeBlock code={scriptExample} />

            <h6 className="mb-2 mt-3 fs-12">{t('sourceLeads.help.howItWorksTitle')}</h6>
            <p className="fs-12 mb-3">{t('sourceLeads.help.howItWorks')}</p>

            <h6 className="mb-2 fs-12">{t('sourceLeads.help.securityTitle')}</h6>
            <p className="fs-12 mb-3">{t('sourceLeads.help.security')}</p>

            <h6 className="mb-2 fs-12">{t('sourceLeads.help.fieldsTitle')}</h6>
            <Table responsive className="table-sm align-middle fs-12 mb-3" style={{ minWidth: '420px' }}>
                <thead>
                    <tr className="bg-light">
                        <th style={{ width: '120px' }}>{t('sourceLeads.help.fieldsTable.field')}</th>
                        <th>{t('sourceLeads.help.fieldsTable.aliases')}</th>
                    </tr>
                </thead>
                <tbody>
                    {fieldGroups.map((field) => (
                        <tr key={field}>
                            <td>{t(`sourceLeads.help.fieldsTable.${field}.label`)}</td>
                            <td className="text-break">
                                <code>{t(`sourceLeads.help.fieldsTable.${field}.aliases`)}</code>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </Table>

            <h6 className="mb-2 fs-12">{t('sourceLeads.help.scriptParamsTitle')}</h6>
            <Table responsive className="table-sm align-middle fs-12 mb-0" style={{ minWidth: '420px' }}>
                <thead>
                    <tr className="bg-light">
                        <th style={{ width: '140px' }}>{t('sourceLeads.help.scriptParamsTable.param')}</th>
                        <th style={{ width: '90px' }}>{t('sourceLeads.help.scriptParamsTable.required')}</th>
                        <th>{t('sourceLeads.help.scriptParamsTable.description')}</th>
                    </tr>
                </thead>
                <tbody>
                    {scriptParams.map((param) => (
                        <tr key={param}>
                            <td>
                                <code>{param}</code>
                            </td>
                            <td>{t(`sourceLeads.help.scriptParams.${param}.required`)}</td>
                            <td className="text-break">{t(`sourceLeads.help.scriptParams.${param}.description`)}</td>
                        </tr>
                    ))}
                </tbody>
            </Table>

            <p className="text-muted fs-12 mt-3 mb-0">{t('sourceLeads.help.notes')}</p>
        </div>
    );
};

export default SourceLeadsHelp;
